import { render, staticRenderFns } from "./MixResults.vue?vue&type=template&id=39661c7c"
import script from "./MixResults.vue?vue&type=script&lang=ts"
export * from "./MixResults.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports